/********************************************************************************
* Copyright (c) 2020 Cedalo GmbH
*
* This program and the accompanying materials are made available under the
* terms of the Eclipse Public License 2.0 which is available at
* http://www.eclipse.org/legal/epl-2.0.
*
* SPDX-License-Identifier: EPL-2.0
*
********************************************************************************/
const runCallback = (context) => (handler) => {
	try {
		handler(context);
	} catch (err) {
		/* ignore */
	}
};

class TermContext {
	constructor(term) {
		this._term = term;
		this._disposeListeners = new Set();
		this._callDisposeListener = runCallback(this);
		// default props:
		this.sheet = undefined;
	}

	get term() {
		return this._term;
	}

	// cell not necessary available, e.g. for shape terms
	get cell() {
		return this._term && !this._term.isDisposed && this._term.cell;
	}

	get isDisposed() {
		return this._term.isDisposed;
	}
	
	copy(term) {
		return new TermContext(term);
	}

	// TODO: rename??
	addDisposeListener(fn) {
		this._disposeListeners.add(fn);
	}

	// TODO: rename??
	getDisposeListeners() {
		return Array.from(this._disposeListeners.values());
	}

	// TODO: rename??
	hasDisposeListener(fn) {
		return this._disposeListeners.has(fn);
	}

	// TODO: rename??
	removeDisposeListener(fn) {
		this._disposeListeners.delete(fn);
	}

	dispose() {
		this._disposeListeners.forEach(this._callDisposeListener);
		this._disposeListeners.clear();
		// remove default props:
		delete this.sheet;
	}
}

module.exports = TermContext;
